/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { useFlags as useLDFlags } from 'launchdarkly-react-client-sdk';

export type BooleanFeatureFlags =
  | 'dedicatedEndpointsRag'
  | 'dedicatedEndpointVersions'
  | 'dedicatedEndpointsMonthlyUsage'
  | 'dedicatedEndpointMetrics'
  | 'dedicatedEndpointLogs'
  | 'dedicatedEndpointsDevProdSelect'
  | 'dedicatedEndpointsH100Autoscaling';

export const useFlags = () => useLDFlags<{ [key in BooleanFeatureFlags]: boolean }>();
